module.exports = __webpack_public_path__ + "static/media/ibd_arm2.9f237a8b.png";